import Link from 'next/link'

import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Flex, Icon } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import clockGlyph from 'Assets/_Legacy/Svg/clock.svg'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled(Flex)
  .attrs({
    width: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    px: [16, 40],
    pt: [16, 24],
    pb: [16, 53],
  })
  .withConfig({
    shouldForwardProp,
  })`
  height: 100%;
`

export const MainContent = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  flex-grow: 1;
`

export const ImageHolder = styled(Flex)`
  width: 100%;
  flex-shrink: 0;
  overflow: hidden;
  background-color: ${themeGet('colors.bunting')};
  cursor: pointer;

  div:first-child {
    max-width: unset !important;
    width: 100%;
  }
`

export const Container = styled(Flex)
  .attrs({
    width: 1,
    flexDirection: 'column',
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: relative;
  background-color: ${themeGet('colors.white')};
  border-radius: 24px;
  overflow: hidden;
  transition: ${themeGet('transition')};
  }
`

export const FooterContent = styled(Flex)`
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  row-gap: 16px;
`

export const ClockIcon = styled(Icon).attrs({
  glyph: clockGlyph,
  size: 20,
})`
  margin-right: 12px;
`

export const BlogLink = styled(Link)`
  cursor: pointer;
  text-decoration: none;

  > h2 {
    color: ${themeGet('colors.text.link')};

    &:hover {
      color: ${themeGet('colors.text.linkHover')};
    }
  }
`
